import * as React from 'react';
import Highstock from 'highcharts/highstock';
import HighchartsReact  from 'highcharts-react-official';
import HighchartMore from 'highcharts/highcharts-more';
import StockTheme from '../stockTheme';

(window as any).Highstock = Highstock;
HighchartMore(Highstock);
require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/offline-exporting')(Highstock);
Highstock.setOptions(StockTheme as any);

const StockChart = ({ options, refs, callback }) => (
  <HighchartsReact
    highcharts={Highstock}
    constructorType={'stockChart'}
    options={options}
    ref={refs}
    callback={callback}
  />
);
export default StockChart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/components/Stock.tsx